import type { ReactNode } from 'react';

import { useMsg, type MaybeMsg } from '../i18n/msg';
import { InboxIcon } from '../layout/icons';

export interface EmptyStateProps {
  /** A Msg is translated here at render, so stored errors follow a language switch. */
  title: MaybeMsg;
  description?: MaybeMsg | null;
  /** Glyph in place of the default mark - keeps one empty pattern across the panels. */
  icon?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({ title, description, icon, action, compact = false }: EmptyStateProps) {
  const tr = useMsg();
  return (
    <div className={compact ? 'empty-state empty-state--compact' : 'empty-state'}>
      <div className="empty-state__mark" aria-hidden={true}>{icon || <InboxIcon size={26} />}</div>
      <div className="empty-state__title">{tr(title)}</div>
      {description ? <p className="empty-state__description">{tr(description)}</p> : null}
      {action ? <div className="empty-state__action">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
